var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isZoomReady)?_c('div',[(_vm.isShowMainClientPage)?_c('div',[_c('ZoomMainClientPage')],1):_c('div',[_c('ZoomStarterPage')],1)]):_c('div',[_c('div',{staticClass:"w-screen h-screen flex justify-center items-center"},[_c('aha-spinner',{attrs:{"variant":'dark',"size":"xl"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }